<template>
    <DynamicHero :slides="slides" fallbackTitle="" fallbackDescription="" fallbackButtonText="" fallbackButtonLink=""
        breadcrumbLabel="" />
    <About v-if="!isLoading && services.length > 0" :services="services" />
    <About v-else />

    <LearnMoreAboutUs />

    <SomeOfWorks v-if="!isLoading && works.length > 0" :works="works" />
    <SomeOfWorks v-else />

    <Client v-if="!isLoading && clients.length > 0" :clients="clients" />
    <Client v-else />
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { fetchHomeData } from '@/services/api'

import DynamicHero from '../components/DynamicHero.vue'
import Hero from '../components/Hero.vue'
import About from '../components/About.vue'
import LearnMoreAboutUs from '../components/LearnMoreAboutUs.vue'
import SomeOfWorks from '../components/SomeOfWorks.vue'
import Client from '../components/Client.vue'

const slides = ref([])
const services = ref([])
const works = ref([])
const clients = ref([])
const isLoading = ref(true)

onMounted(async () => {
    try {
        const data = await fetchHomeData()
        slides.value = data.slides || []
        services.value = data.services || []
        works.value = data.works || []
        clients.value = data.clients || []
    } catch (error) {
        console.error('Failed to load home data:', error)
    } finally {
        isLoading.value = false
    }
})
</script>
